/**
 * @file React hook that outputs the component unique id
 */

import { useRef } from 'react';

let uniqueId = 0;

/**
 * Get unique ID for the component
 *
 * @returns The ID to use
 */
const getUniqueId = () => uniqueId++;

/**
 * React hook that outputs the component unique id
 * it uses refs to preserve value after rerenders
 *
 * @param prefix String prefix for the component ID
 * @returns      ID of the component as a number
 */
const useComponentId = (prefix: string): string => {
  const idRef = useRef<number>();
  if (idRef.current === undefined) {
    idRef.current = getUniqueId();
  }

  return prefix + '-' + idRef.current;
};

export default useComponentId;
